/////////////////////////////////////////////////
///
///  DO NOT MODIFY: This file was auto-generated.
///  To rebuild, run `tsx ./scripts/build`
///
/////////////////////////////////////////////////

import { z } from "zod";
import {
  AgendaControllerResponseSchema,
  AgendaItemControllerResponseSchema,
  AgendaModuleControllerResponseSchema,
  ConfigControllerResponseSchema,
  DocumentControllerResponseSchema,
  InternalMessagingControllerResponseSchema,
  MeetingControllerResponseSchema,
  MunicipalityControllerResponseSchema,
  PrivateAIControllerResponseSchema,
  PrivateAIMinutesTemplateControllerResponseSchema,
  PrivateAccountControllerResponseSchema,
  PrivateAgendaControllerResponseSchema,
  PrivateAgendaItemControllerResponseSchema,
  PrivateAgendaModuleControllerResponseSchema,
  PrivateConfigControllerResponseSchema,
  PrivateDocumentControllerResponseSchema,
  PrivateImportControllerResponseSchema,
  PrivateLaserficheIntegrationControllerResponseSchema,
  PrivateLetterheadControllerResponseSchema,
  PrivateMeetingControllerResponseSchema,
  PrivateMiscControllerResponseSchema,
  PrivateSignRequestControllerResponseSchema,
  PrivateSiteControllerResponseSchema,
  PrivateTeamControllerResponseSchema,
  PrivateTenantControllerResponseSchema,
  PrivateUserControllerResponseSchema,
  ScheduledControllerResponseSchema,
  SiteControllerResponseSchema,
  StripeControllerResponseSchema,
  SuperadminControllerResponseSchema,
  TeamControllerResponseSchema,
  TenantControllerResponseSchema,
  TestControllerResponseSchema,
  UserControllerResponseSchema,
  WebhookControllerResponseSchema,
} from "./schema.index";

export type ControllerSchemasType = Record<
  string,
  Record<string, z.ZodType | undefined> | undefined
>;

export const ControllerSchemas = {
  AgendaController: AgendaControllerResponseSchema,
  AgendaItemController: AgendaItemControllerResponseSchema,
  AgendaModuleController: AgendaModuleControllerResponseSchema,
  ConfigController: ConfigControllerResponseSchema,
  DocumentController: DocumentControllerResponseSchema,
  InternalMessagingController: InternalMessagingControllerResponseSchema,
  MeetingController: MeetingControllerResponseSchema,
  MunicipalityController: MunicipalityControllerResponseSchema,
  PrivateAIController: PrivateAIControllerResponseSchema,
  PrivateAIMinutesTemplateController: PrivateAIMinutesTemplateControllerResponseSchema,
  PrivateAccountController: PrivateAccountControllerResponseSchema,
  PrivateAgendaController: PrivateAgendaControllerResponseSchema,
  PrivateAgendaItemController: PrivateAgendaItemControllerResponseSchema,
  PrivateAgendaModuleController: PrivateAgendaModuleControllerResponseSchema,
  PrivateConfigController: PrivateConfigControllerResponseSchema,
  PrivateDocumentController: PrivateDocumentControllerResponseSchema,
  PrivateImportController: PrivateImportControllerResponseSchema,
  PrivateLaserficheIntegrationController: PrivateLaserficheIntegrationControllerResponseSchema,
  PrivateLetterheadController: PrivateLetterheadControllerResponseSchema,
  PrivateMeetingController: PrivateMeetingControllerResponseSchema,
  PrivateMiscController: PrivateMiscControllerResponseSchema,
  PrivateSignRequestController: PrivateSignRequestControllerResponseSchema,
  PrivateSiteController: PrivateSiteControllerResponseSchema,
  PrivateTeamController: PrivateTeamControllerResponseSchema,
  PrivateTenantController: PrivateTenantControllerResponseSchema,
  PrivateUserController: PrivateUserControllerResponseSchema,
  ScheduledController: ScheduledControllerResponseSchema,
  SiteController: SiteControllerResponseSchema,
  StripeController: StripeControllerResponseSchema,
  SuperadminController: SuperadminControllerResponseSchema,
  TeamController: TeamControllerResponseSchema,
  TenantController: TenantControllerResponseSchema,
  TestController: TestControllerResponseSchema,
  UserController: UserControllerResponseSchema,
  WebhookController: WebhookControllerResponseSchema,
} as ControllerSchemasType;
